import React, { useState } from "react";
import Accordion from "./Accordion";
import referImg from "../asset/img/refer-about.jpg"
import creditImg from "../asset/img/credit-card-about.jpg"
import loanImg from "../asset/img/loan-about.jpg"
import savingsImg from "../asset/img/saving-about.jpg"

export default function About() {
  const accordionItems = [
    {
      title: "About Us",
      content:
        "Grahaksathi is a tech-enabled platform where customers are guided to the right financial product from the right bank or NBFC. It is also a thoughtfully accented concept where individuals (from all the profiles) are offered career options as a financial advisor and make income flexibly.",
       
    },
    {
      title: "Why Choose Us",
      content:
        "Start Your Business with Zero Investment and Earn over ₹25000/- Every Month. Provide financial advice and products to the customers and get a fast payout every month.",
    },
    { title: "Accordion #3", content: "Content for Accordion #3" },
  ];

  const data = [
    {
      title:"UPI Referral Program",
      content:"Provide UPI to your customers and help them Instant transactions. You can start making payments instantly after a quick registration process.promotes a cashless economy. Rewards and cashback. Privacy protection. Transactions through multiple accounts.",
      imgPath:referImg
    },
    {
      title:"Saving Account",
      content:"Provide Zero Balance saving accounts to your customers and help them earn more on their savings.",
      imgPath:savingsImg
    },
    {
      title:"Credit Card",
      content:"Make your customers pamper their lifestyle choices with the suitable credit cards. Offer a variety of credit cards from the top banks.",
      imgPath:creditImg
    },
    {
      title:"Loans",
      content:"Provide personal loans, home loans and more to your customers at interesting deals from the best lenders.",
      imgPath:loanImg
    },
  ]
  const [expandedParagraphs, setExpandedParagraphs] = useState(
    new Array(accordionItems.length).fill(false)
  );

  const toggleExpansion = (index) => {
    const newExpandedParagraphs = [...expandedParagraphs];
    newExpandedParagraphs[index] = !newExpandedParagraphs[index];
    setExpandedParagraphs(newExpandedParagraphs);
  };
  const limitText = (text) => {
    return text.length > 80 ? text.slice(0, 80) + "..." : text;
  };

  return (
    <>
      <main class="pt-8 pb-16 lg:pt-16 lg:pb-24 bg-white ">
        <div class="flex justify-between px-4 mx-auto max-w-screen-xl ">
          <article class="mx-auto w-full max-w-2xl format format-sm sm:format-base lg:format-lg format-blue dark:format-invert">
            <header class="mb-4 lg:mb-6 not-format">
              <h1 class="mb-8 mt-20   text-center text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                About Us
              </h1>
            </header>
            <p class="lead">
              Grahaksathi is a tech-enabled platform where customers are guided
              to the right financial product from the right bank or NBFC. It is
              also a thoughtfully accented concept where individuals (from all
              the profiles) are offered career options as a financial advisor
              and make income flexibly.
            </p>

            {/* dropdown */}

            <Accordion items={accordionItems} />

            {/* dropdown */}

            <header class="mb-4 lg:mb-6 not-format">
              <h1 class="mb-4 mt-10 text-center text-2xl font-bold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white">
                Why Choose Us
              </h1>
            </header>
            <p class="lead">
              Start Your Business with Zero Investment and Earn over ₹25000/-
              Every Month. Provide financial advice and products to the
              customers and get a fast payout every month.
            </p>
          </article>
        </div>
      </main>

      <aside
        aria-label="Related articles"
        class="py-8 lg:py-24 bg-gray-50 dark:bg-gray-800"
      >
        <div class="px-4 mx-auto max-w-screen-xl">
          {/* <h2 class="mb-8 text-2xl font-bold text-gray-900 dark:text-white">
            Related articles
          </h2> */}
          <div class="grid gap-12 sm:grid-cols-2 lg:grid-cols-4">
            {data.map((item,index)=>(
            <article class="max-w-xs">
              <a href="/refer-upi">
                <img
                  src={item.imgPath}
                  class="mb-5 rounded-lg"
                  alt="Image2"
                />
              </a>
              <h2 class="mb-2 text-xl font-bold leading-tight text-gray-900 dark:text-white">
                <a href="/refer-upi">{item.title}</a>
              </h2>
              <p className="mb-4 font-light text-gray-500 dark:text-gray-400">
              {expandedParagraphs[index]
              ? item.content
              : limitText(item.content)}
            {!expandedParagraphs[index] && (
              <span
                className="text-primary-600 cursor-pointer"
                onClick={() => toggleExpansion(index)}
              >
                Read More
              </span>
            )}
              </p>
              {/* <a href="/refer-upi" class="inline-flex items-center font-medium underline underline-offset-4 text-primary-600 dark:text-primary-500 hover:no-underline">
                Read more
              </a> */}
            </article>

            ))}
          
          </div>
        </div>
      </aside>

      {/* *********** */}

      {/* ********* */}
    </>
  );
}
